import {
  IsNotEmpty,
  IsOptional,
  IsString,
  IsArray,
  ValidateNested,
} from "class-validator";
import { Type, Transform } from "class-transformer";
import { DogCoownerInfoDto } from "./dog-coowner-info.dto";
import { DogClubRegistrationDto } from "./club-registration.dto";

class ChangeFieldDto<T> {
  @IsOptional()
  old?: T;

  @IsOptional()
  new?: T;
}

class CoownerChangeDto {
  @IsOptional()
  @ValidateNested()
  @Type(() => DogCoownerInfoDto)
  old?: DogCoownerInfoDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => DogCoownerInfoDto)
  new?: DogCoownerInfoDto;
}

class ClubRegistrationChangeDto {
  @IsOptional()
  @ValidateNested()
  @Type(() => DogClubRegistrationDto)
  old?: DogClubRegistrationDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => DogClubRegistrationDto)
  new?: DogClubRegistrationDto;
}

export class DogProposedChangesDto {
  @IsNotEmpty()
  @IsString()
  event_id: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  sex?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  dob?: ChangeFieldDto<Date>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  weight?: ChangeFieldDto<number>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  height_at_withers?: ChangeFieldDto<number>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  final_response?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  country_of_birth?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  image_url?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  breeder?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  sire?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  dam?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  breed?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  variety?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  registered_name?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  call_name?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  prefix_title?: ChangeFieldDto<string>;

  @IsOptional()
  @ValidateNested()
  @Type(() => ChangeFieldDto)
  suffix_title?: ChangeFieldDto<string>;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CoownerChangeDto)
  @Transform(({ value }) => (Array.isArray(value) && value.length === 0 ? undefined : value))
  coowners?: CoownerChangeDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ClubRegistrationChangeDto)
  @Transform(({ value }) => (Array.isArray(value) && value.length === 0 ? undefined : value))
  club_registrations?: ClubRegistrationChangeDto[];
}
